// src/App.jsx
import { useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import KpiSummaryPage from "./pages/KpiSummary";
import AppBar from "./components/AppBar";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";
import KpiDetail from "./pages/KpiDetail";

export default function App() {
  const [user, setUser] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            main: darkMode ? "#90caf9" : "#1976d2",
            contrastText: darkMode ? "#121212" : "#ffffff",
          },
          background: {
            default: darkMode ? "#121212" : "#f5f5f5",
            paper: darkMode ? "#1e1e1e" : "#ffffff",
          },
          text: {
            primary: darkMode ? "#ffffff" : "rgba(0, 0, 0, 0.87)",
            secondary: darkMode
              ? "rgba(255, 255, 255, 0.7)"
              : "rgba(0, 0, 0, 0.6)",
          },
        },
        typography: {
          fontFamily: "'Inter', sans-serif",
        },
        components: {
          MuiAppBar: {
            styleOverrides: {
              root: {
                backgroundColor: darkMode ? "#1e1e1e" : "#1976d2",
              },
            },
          },
        },
      }),
    [darkMode]
  );

  const handleLogout = () => setUser(null);

  return (
    <GoogleOAuthProvider clientId="520066600754-rqsc8r3dftbr5nisflg0d0gg6bf7luqn.apps.googleusercontent.com">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          {user && (
            <AppBar
              user={user}
              toggleTheme={() => setDarkMode(!darkMode)}
              onLogout={handleLogout}
            />
          )}
          <main>
            <Routes>
              {/* Public route */}
              <Route path="/" element={<KpiSummaryPage />} />

              {/* Auth routes */}
              <Route
                path="/login"
                element={
                  !user ? (
                    <Login onLogin={setUser} />
                  ) : (
                    <Navigate to="/dashboard" />
                  )
                }
              />
              <Route
                path="/dashboard"
                element={user ? <Dashboard user={user} /> : <Navigate to="/" />}
              />

              <Route
                path="/kpi-list/:perusahaan/:tahun"
                element={<KpiDetail />}
              />
            </Routes>
          </main>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}
